import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  isOpen: boolean;
};

const initialState: InitialState = {
  isOpen: false,
};

const projectStatusFilterSlice = createSlice({
  name: "projectStatusFilter",
  initialState,
  reducers: {
    setIsOpen(state, action: PayloadAction<{ isOpen: boolean }>) {
      state.isOpen = action.payload.isOpen;
    },
  },
});

export const { setIsOpen } = projectStatusFilterSlice.actions;

export default projectStatusFilterSlice;
